<template>
    <div v-if="isEditMode" style="width:100%; height:100%; display:flex; align-items:center">
        <!--<ur-text-field style="width:200px" ref="textField" :key="byteKey" v-model="textValue" @enter="onClickSaveButton" @blur="onTextFieldBlur"/>-->
        <aicc-text-field style="width:200px" ref="textField" v-model="textValue" @enter="onClickSaveButton" @blur="onTextFieldBlur" :rules="rule" :counter="descriptionMaxBytes" :counterShow="false" @invalid="invalid"/>
        <ur-button @mousedown="onMouseDownSaveButton" @click="onClickSaveButton" :disabled="!isDescriptionValid" small primary solid text="저장" style="margin-left:8px"/>
    </div>
    <div v-else style="width:100%; height:100%">
        <div class="view_mode_div" style="float:left;">
            {{row.description}}
        </div>
        <div class="view_mode_div" style="float:right; margin-right:140px">
            <button class="btn_modify" @click="onClickEditButton"/>
        </div>
    </div>
</template>
<script>
export default {
    name:'PGE_AIM_00001_C01',
    components:{},
    props:{
        row:{type:Object, default: () => {},},
        value:{type:String, default:'',}
    },
    data(){
        return {
            descriptionMaxBytes:20,
            isEditMode:false,
            textValue:'',
            mouseDown:false,
            byteKey:0,
            rule:[
                v => aiccUtils.getStringByteSize(v) <= this.descriptionMaxBytes || '',
            ],
        }
    },
    created(){},
    mounted(){},
    computed:{
        contextPageId() {
            if (this._props._params && this._props._params.routerOriginPageId) {
                return this._props._params.routerOriginPageId;
            }
            if(this.$options.name.length > 13) {
                return this.$options.name.substr(0,13);
            }
            return this.$options.name;
        },
        isDescriptionValid(){
            const byte = aiccUtils.getStringByteSize(this.textValue);
            if(byte > this.descriptionMaxBytes) {
                return false;
            } else {
                return true;
            }
        },
    },
    watch:{
        textValue: {
            immediate: true,
            handler(newValue, oldValue) {
                /*
                if(aiccUtils.getStringByteSize(newValue) > 20) {
                //if(newValue && newValue.length > 20) {
                    this.textValue = oldValue;
                    this.onMouseDownSaveButton();
                    this.byteKey++;
                    this.$nextTick(() => {
                        this.$refs['textField'].focus();
                        this.mouseDown = false;
                    })
                }
                */
            }
        },
    },
    methods:{
        getByteSize(str){
            let totalByte = 0;
            if(str) {
                for(let ii = 0 ; ii < str.length ; ii++) {
                    const currChar = str.charAt(ii);
                    const uniCurrChar = escape(currChar);
                    if(uniCurrChar.length > 4) {
                            totalByte += 2;
                    } else {
                        totalByte += 1;
                    }
                }
            }
            return totalByte;
        },
        onMouseDownSaveButton(){
            this.mouseDown = true;
        },
        onClickSaveButton(){
            if(aiccUtils.getStringByteSize(this.textValue) > this.descriptionMaxBytes) {
                return;
            }
            this.row.description = this.textValue;
            http.request(this.contextPageId, 'DTS_AIM_00004', {
                data:{
                    sipNumberInfo:this.row,
                }
            })
            .then(res => {
                this.mouseDown = false;
                this.isEditMode = false;
            })
            .catch(error => {
                this.mouseDown = false;
            });
        },
        onClickEditButton(){
            if(this.isEditMode === false) {
                this.textValue = this.row.description;
            }
            this.isEditMode = !this.isEditMode;
            this.$nextTick(() => {
                if(this.isEditMode === true) {
                    this.$refs['textField'].focus();
                }
            });
        },
        onTextFieldBlur(){
            if(this.mouseDown === false) {
                this.isEditMode = false;
            }
        },
        getComponent(name) {
            let component = null;
            let thisComponent = this;
            while(thisComponent && !component) {
                if(thisComponent.$options.name === name) {
                    component = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }
            return component;
        },
        invalid(){
            const component = this.getComponent('PGE_AIM_00001');
            if(!!component) {
                component.showSnackbar('최대 '+this.descriptionMaxBytes+'byte까지 입력 가능합니다.');
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .view_mode_div {
        height:100%; display:flex; align-items:center
    }
    .btn_modify {
        width:16px;
        height:16px;
        background:url('../../../../../assets/images/aicc/ic_modify.png');
    }
    /*
    .ur-text-field .ur-input .ur-text-field--medium .ur-text-field--border input:focus {
        background-color: #FFF;
    }
    .ur-text-field__input:focus {
        background-color: #FFF;
    }
    */
    ::v-deep .ur-text-field > .ur-text-field__input:focus {
        background-color: #FFF;
    }
    .ur-text-field > .ur-text-field__input:focus {
        background-color: #FFF;
    }
</style>